import { z } from 'zod';

const phoneNumberRegex = /^(\(?[0-9]{3}\)?[-.\s]?[0-9]{3}[-.\s]?[0-9]{4}|[0-9]{10})$/;

const providerFields = {
  serviceType: z.enum(['SP', 'OT', 'CO', 'PT', 'Para']),
  startDate: z.string().min(1, 'Start date is required'),
  providerName: z.string().min(1, 'Provider name is required'),
  providerPhoneNumber: z
    .string()
    .min(1, 'Provider phone number is required')
    .regex(phoneNumberRegex, 'Please enter a valid phone number'),
};

const agencyFields = {
  agencyName: z.string().min(1, 'Agency name is required'),
  agencyPhoneNumber: z
    .string()
    .min(1, 'Agency phone number is required')
    .regex(phoneNumberRegex, 'Please enter a valid phone number'),
};

const notServicedFields = {
  serviceType: z.enum(['SP', 'OT', 'CO', 'PT', 'Para']),
  reason: z.string().min(1, 'Reason is required'),
};

export const serviceAgencyFormSchema = z.object({
  ...providerFields,
  ...agencyFields,
});

export const serviceIndependentFormSchema = z.object({
  ...providerFields,
});

export const serviceNotServicedFormSchema = z.object({
  ...notServicedFields,
});

export type ServiceAgencyFormData = z.infer<typeof serviceAgencyFormSchema>;
export type ServiceIndependentFormData = z.infer<typeof serviceIndependentFormSchema>;
export type ServiceNotServicedFormData = z.infer<typeof serviceNotServicedFormSchema>;
